import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import "./App.scss";
import {
  fetchSubsystems,
  fetchComponents
} from "./stores/actions/sensorActions";
import { encourstartdate, encourenddate } from "./stores/actions/blockdate";

import axios from "axios";
import DefaultLayout from "./containers/DefaultLayout/DefaultLayout";
let yourConfig = { headers: { Authorization: "Bearer " + localStorage.getItem("authToken") } }





/* test pour GIC PIPELINE  const url = 'https://admin.svom.eu/keycloak/realms/svom-fsc/protocol/openid-connect/token';
  const params = new URLSearchParams();
   params.append('client_id', 'GIC');
   params.append('client_secret', '7f73933a-e541-4a76-b744-462319cdd550');
  params.append('grant_type', 'client_credentials');*/

class App extends Component {
  constructor() {
    super();
    this.state = {
      token: ""
    };
    this.getKeycloakToken = this.getKeycloakToken.bind(this);
  }

  componentDidMount() {
    
    //ANNULE TEST
    this.getKeycloakToken();
    if (this.props.blockdate.encourstartdate.length === 0) {
     let datefin = moment().subtract(1, "months").toDate();
      this.props.fetchSubsystems(
        moment(datefin).format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ); 




    } else {
      this.props.fetchSubsystems(
        this.props.blockdate.encourstartdate,
        this.props.blockdate.encourenddate
      );
    }

    if (this.props.blockdate.encourstartdate.length === 0) {
      let datestart = moment().subtract(24, "hours").toDate();
      this.props.encourstartdate(moment(datestart).format());
    }

    if (this.props.blockdate.encourenddate.length === 0) {
      this.props.encourenddate(moment().format());
    }





  }

 getKeycloakToken = async () => {
    try {
      const url =
        "https://admin.svom.eu/keycloak/";
      const params = new URLSearchParams();
      params.append("client_id", "GIC");
      params.append("client_secret", "7f73933a-e541-4a76-b744-462319cdd550");
      params.append("grant_type", "client_credentials");


   
      const config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded",  Authorization: `Bearer ${yourConfig}`  }
      };
      const response = await axios.post(url, params, config);

      // Récupérer le token d'accès depuis la réponse
      const token = response.data.access_token;
   
      this.setState({ token: token });
      // Utiliser le token pour les appels API
    } catch (error) {
      console.error(
        "Erreur lors de la récupération du token Keycloak:",
        error
      );
    }
  }; 



  render() {
    return (
      <>
        <h1>{this.state.token}</h1>

        <Route path="/gic-web/" component={DefaultLayout} />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  ...state
});

const mapDispatchToProps = {
  fetchSubsystems,
  fetchComponents,
  encourstartdate,
  encourenddate
};

// @ts-ignore
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
